var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIconIntro2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_162854",
    "data-name": "\\uADF8\\uB8F9 162854",
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 47,
    viewBox: "0 0 81 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_325",
    "data-name": "\\uD0C0\\uC6D0 325",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    fill: "#adcfeb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_329",
    "data-name": "\\uD0C0\\uC6D0 329",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(13)",
    fill: "#adcfeb"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_333",
    "data-name": "\\uD0C0\\uC6D0 333",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(26)",
    fill: "#adcfeb"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_337",
    "data-name": "\\uD0C0\\uC6D0 337",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(39)",
    fill: "#adcfeb"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_341",
    "data-name": "\\uD0C0\\uC6D0 341",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(52)",
    fill: "#adcfeb"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_345",
    "data-name": "\\uD0C0\\uC6D0 345",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(65)",
    fill: "#adcfeb"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_349",
    "data-name": "\\uD0C0\\uC6D0 349",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(78)",
    fill: "#adcfeb"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_326",
    "data-name": "\\uD0C0\\uC6D0 326",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0 12)",
    fill: "#adcfeb"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_330",
    "data-name": "\\uD0C0\\uC6D0 330",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(13 12)",
    fill: "#adcfeb"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_334",
    "data-name": "\\uD0C0\\uC6D0 334",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(26 12)",
    fill: "#adcfeb"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_338",
    "data-name": "\\uD0C0\\uC6D0 338",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(39 12)",
    fill: "#adcfeb"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_342",
    "data-name": "\\uD0C0\\uC6D0 342",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(52 12)",
    fill: "#adcfeb"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_346",
    "data-name": "\\uD0C0\\uC6D0 346",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(65 12)",
    fill: "#adcfeb"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_350",
    "data-name": "\\uD0C0\\uC6D0 350",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(78 12)",
    fill: "#adcfeb"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_327",
    "data-name": "\\uD0C0\\uC6D0 327",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0 23)",
    fill: "#adcfeb"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_331",
    "data-name": "\\uD0C0\\uC6D0 331",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(13 23)",
    fill: "#adcfeb"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_335",
    "data-name": "\\uD0C0\\uC6D0 335",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(26 23)",
    fill: "#adcfeb"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_339",
    "data-name": "\\uD0C0\\uC6D0 339",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(39 23)",
    fill: "#adcfeb"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_343",
    "data-name": "\\uD0C0\\uC6D0 343",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(52 23)",
    fill: "#adcfeb"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_347",
    "data-name": "\\uD0C0\\uC6D0 347",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(65 23)",
    fill: "#adcfeb"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_351",
    "data-name": "\\uD0C0\\uC6D0 351",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(78 23)",
    fill: "#adcfeb"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_328",
    "data-name": "\\uD0C0\\uC6D0 328",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0 34)",
    fill: "#adcfeb"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_332",
    "data-name": "\\uD0C0\\uC6D0 332",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(13 34)",
    fill: "#adcfeb"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_336",
    "data-name": "\\uD0C0\\uC6D0 336",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(26 34)",
    fill: "#adcfeb"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_340",
    "data-name": "\\uD0C0\\uC6D0 340",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(39 34)",
    fill: "#adcfeb"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_344",
    "data-name": "\\uD0C0\\uC6D0 344",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(52 34)",
    fill: "#adcfeb"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_348",
    "data-name": "\\uD0C0\\uC6D0 348",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(65 44)",
    fill: "#adcfeb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconIntro2);
export default __webpack_public_path__ + "static/media/navIconIntro2_.f9e012cd3674347e255e15478e586844.svg";
export { ForwardRef as ReactComponent };